import React, { useState, useEffect } from 'react';
import { obtenerFechasPago, obtenerTodosControlPagos, verificarPagosAnterioresHistorial } from '../../services/pagosServices';
import { obtenerMatriculaPorId, actualizarMatricula } from '../../services/matriculaService';
import { obtenerPlanes } from '../../services/centroService';
import { Loader, CreditCard, ArrowLeft, RefreshCw, CheckCircle } from 'lucide-react';
import Pagos from '../pagos/pagos';
import Transferencia from './transferencia';
import { FaExchangeAlt } from 'react-icons/fa';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ControladorPago = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [mostrarPago, setMostrarPago] = useState(false);
    const [metodoPago, setMetodoPago] = useState('');
    const [matriculaId, setMatriculaId] = useState(null);
    const [transferenciaPendiente, setTransferenciaPendiente] = useState(false);
    const [pagoTarjetaPendiente, setPagoTarjetaPendiente] = useState(false);
    const [mostrarMensajeTransferencia, setMostrarMensajeTransferencia] = useState(false);
    const [mostrarSeleccionPlan, setMostrarSeleccionPlan] = useState(true);
    const [planes, setPlanes] = useState([]);
    const [planActual, setPlanActual] = useState(null);
    const [planSeleccionado, setPlanSeleccionado] = useState(null);
    const [tienePagosAnteriores, setTienePagosAnteriores] = useState(false);
    const [loadingPlanes, setLoadingPlanes] = useState(false);

    const verificarPagosPendientes = async (idMatricula) => {
        try {
            const response = await obtenerTodosControlPagos();
            if (response.success) {
                const transferencias = response.data.filter(
                    pago => pago.tipo_pago === 'Transferencia' && 
                           pago.estado === 'Pendiente' &&
                           pago.estado_verificacion === 'Pendiente' && // Solo transferencias en revisión
                           pago.imagen_comprobante &&
                           pago.id_matricula === idMatricula // Validación por matrícula específica
                );
                setTransferenciaPendiente(transferencias.length > 0);
                
                const pagosTarjeta = response.data.filter(
                    pago => pago.tipo_pago === 'Tarjeta' && 
                           pago.estado === 'Pendiente' &&
                           pago.estado_verificacion === 'Pendiente' &&
                           pago.id_matricula === idMatricula
                );
                setPagoTarjetaPendiente(pagosTarjeta.length > 0);
            }
        } catch (err) {
            console.error('Error al verificar pagos pendientes:', err);
        }
    };

    const verificarEstadoPago = async (idMatricula) => {
        try {
            const fechasResponse = await obtenerFechasPago(idMatricula);
            
            if (fechasResponse.success) {
                const fechaActual = new Date();
                fechaActual.setHours(0, 0, 0, 0);
                
                if (fechasResponse.data && fechasResponse.data.length > 0) {
                    const ultimoRegistro = fechasResponse.data[fechasResponse.data.length - 1];
                    
                    // Si el último pago fue rechazado, siempre mostrar opción de pago
                    if (ultimoRegistro.estado_verificacion === 'Rechazado') {
                        setMostrarPago(true);
                    } else if (ultimoRegistro.estado_verificacion === 'Pendiente') {
                        // Verificar si es una transferencia pendiente de verificación
                        const tieneTransferenciaPendiente = ultimoRegistro.tipo_pago === 'Transferencia' && 
                                                           ultimoRegistro.comprobante_pago;
                        
                        if (tieneTransferenciaPendiente) {
                            setMostrarPago(false); // No mostrar pago si hay transferencia en revisión
                        } else {
                            // Estado pendiente sin transferencia - verificar fecha
                            if (ultimoRegistro.proxima_fecha_pago) {
                                const proximaFechaPago = new Date(ultimoRegistro.proxima_fecha_pago);
                                proximaFechaPago.setHours(0, 0, 0, 0);
                                const mostrarPagoCalculado = fechaActual >= proximaFechaPago;
                                setMostrarPago(mostrarPagoCalculado);
                            } else {
                                setMostrarPago(true); // Si no hay fecha, permitir pago
                            }
                        }
                    } else if (ultimoRegistro.estado_verificacion === 'Verificado') {
                        // Pago verificado - verificar si necesita próximo pago
                        if (ultimoRegistro.proxima_fecha_pago) {
                            const proximaFechaPago = new Date(ultimoRegistro.proxima_fecha_pago);
                            proximaFechaPago.setHours(0, 0, 0, 0);
                            const mostrarPagoCalculado = fechaActual >= proximaFechaPago;
                            setMostrarPago(mostrarPagoCalculado);
                        } else {
                            setMostrarPago(false); // Si no hay próxima fecha, no requiere pago
                        }
                    } else {
                        console.warn('No se encontró próxima fecha de pago en el último registro para controlador');
                        setMostrarPago(true); // Si no hay fecha, permitir pago
                    }
                } else {
                    setMostrarPago(true); // Si no hay control de pagos, permitir pago
                }
            } else {
                console.warn('Error en la respuesta de fechas de pago para controlador:', fechasResponse);
                setMostrarPago(true); // En caso de error, permitir pago
            }
        } catch (err) {
            console.error('Error al verificar estado de pago en controlador:', err);
            setMostrarPago(true); // En caso de error, permitir pago
        } finally {
            setIsLoading(false);
        }
    };

    const cargarPlanes = async () => {
        try {
            setLoadingPlanes(true);
            const response = await obtenerPlanes();
            if (response.success && response.data) {
                setPlanes(response.data);
            }
        } catch (error) {
            console.error('Error al cargar planes:', error);
            toast.error('Error al cargar los planes disponibles');
        } finally {
            setLoadingPlanes(false);
        }
    };

    const verificarPagosAnteriores = async (idMatricula) => {
        try {
            console.log('Verificando pagos anteriores para matrícula:', idMatricula);
            const response = await verificarPagosAnterioresHistorial(idMatricula);
            console.log('Respuesta de verificación de pagos anteriores:', response);
            
            if (response.success) {
                const tienePagos = response.tienePagosAnteriores;
                console.log(tienePagos ? 'Tiene pagos anteriores - mostrando selección de plan' : 'NO tiene pagos anteriores - primera vez pagando, saltando selección de plan');
                setTienePagosAnteriores(tienePagos);
                return tienePagos;
            } else {
                console.log('Error en la respuesta - asumiendo primera vez pagando');
                setTienePagosAnteriores(false);
                return false;
            }
        } catch (error) {
            console.error('Error al verificar pagos anteriores:', error);
            // En caso de error, asumir que es primera vez
            setTienePagosAnteriores(false);
            return false;
        }
    };

    const actualizarPlanMatricula = async (nuevoPlanId) => {
        try {
            const hijoSeleccionado = JSON.parse(localStorage.getItem('hijoSeleccionado'));
            if (hijoSeleccionado && hijoSeleccionado.id_child) {
                await actualizarMatricula(hijoSeleccionado.id_child, {
                    id_plan: nuevoPlanId
                });
                toast.success('Plan actualizado correctamente');
                return true;
            }
            return false;
        } catch (error) {
            console.error('Error al actualizar plan:', error);
            toast.error('Error al actualizar el plan');
            return false;
        }
    };

    const handleSeleccionarPlan = (plan) => {
        setPlanSeleccionado(plan);
        // Guardar en localStorage para que los componentes de pago puedan acceder
        localStorage.setItem('planSeleccionado', JSON.stringify(plan));
        localStorage.setItem('planActual', JSON.stringify(planActual));
    };

    const procederAlPago = () => {
        setMostrarSeleccionPlan(false);
    };

    // Función para renderizar la descripción con beneficios como viñetas
    const renderDescripcion = (descripcion) => {
        if (!descripcion) return null;
        
        const partes = descripcion.split(';');
        
        if (partes.length <= 1) {
            return <p className="text-gray-600 text-sm mb-3">{descripcion}</p>;
        }
        
        const descripcionBase = partes[0].trim();
        const beneficios = partes.slice(1).filter(beneficio => beneficio.trim());
        
        return (
            <div className="text-gray-600 text-sm mb-3">
                {descripcionBase && (
                    <p className="mb-2">{descripcionBase}</p>
                )}
                {beneficios.length > 0 && (
                    <div>
                        <p className="font-medium text-gray-700 mb-1">Incluye:</p>
                        <ul className="list-disc list-inside space-y-1 text-gray-600">
                            {beneficios.map((beneficio, index) => (
                                <li key={index} className="text-xs">
                                    {beneficio.trim()}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    };

    useEffect(() => {
        const obtenerDatos = async () => {
            try {
                const hijoSeleccionado = JSON.parse(localStorage.getItem('hijoSeleccionado'));
                if (hijoSeleccionado && hijoSeleccionado.id_child) {
                    const response = await obtenerMatriculaPorId(hijoSeleccionado.id_child);
                    const idMatricula = response.matricula.matricula.id_matricula;
                    const matriculaData = response.matricula.matricula;
                    
                    setMatriculaId(idMatricula);
                    
                    // Obtener información del plan actual
                    if (matriculaData.id_plan) {
                        const planesResponse = await obtenerPlanes();
                        if (planesResponse.success && planesResponse.data) {
                            const planActualEncontrado = planesResponse.data.find(p => p.id_plan === matriculaData.id_plan);
                            if (planActualEncontrado) {
                                setPlanActual(planActualEncontrado);
                                setPlanSeleccionado(planActualEncontrado);
                            }
                        }
                    }
                    
                    // Verificar si tiene pagos anteriores
                    const tienePagos = await verificarPagosAnteriores(idMatricula);
                    setTienePagosAnteriores(tienePagos);
                    
                    // Solo cargar planes y mostrar selección si tiene pagos anteriores
                    if (tienePagos) {
                        await cargarPlanes();
                        setMostrarSeleccionPlan(true);
                    } else {
                        // Si es primera vez pagando, ir directo al pago sin selección de plan
                        setMostrarSeleccionPlan(false);
                    }
                    
                    await verificarEstadoPago(idMatricula);
                    await verificarPagosPendientes(idMatricula);
                }
            } catch (err) {
                console.error('Error al obtener datos:', err);
                setIsLoading(false);
            }
        };

        obtenerDatos();
    }, []);

    const volverASeleccion = () => {
        if (mostrarSeleccionPlan) {
            setMostrarSeleccionPlan(true);
            setMetodoPago('');
        } else {
            setMetodoPago('');
        }
    };

    const volverAPlanes = () => {
        setMostrarSeleccionPlan(true);
        setMetodoPago('');
    };

    if (isLoading) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center p-2 sm:p-4">
                <Loader className="w-6 h-6 sm:w-8 sm:h-8 animate-spin text-blue-600 mb-3 sm:mb-4" />
                <p className="text-sm sm:text-base text-gray-600">Verificando estado de pagos...</p>
            </div>
        );
    }



    if (!mostrarPago) {
        return (
            <div className="min-h-screen flex items-center justify-center p-2 sm:p-4">
                <div className="text-center p-6 sm:p-12 backdrop-blur-sm bg-white/40 rounded-xl sm:rounded-3xl shadow-sm border border-green-100/50 transition-all duration-300 hover:shadow-md">
                    <div className="flex flex-col items-center space-y-4 sm:space-y-6">
                        <div className="w-12 h-12 sm:w-16 sm:h-16 bg-green-100 rounded-full flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 sm:h-8 sm:w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <h2 className="text-xl sm:text-2xl font-light text-gray-800">¡Estás al día con tus pagos!</h2>
                        <p className="text-sm sm:text-base text-gray-500 font-light">No hay pagos pendientes en este momento</p>
                    </div>
                </div>
            </div>
        );
    }

    // Modal para mostrar mensaje de transferencia en revisión
    if (mostrarMensajeTransferencia) {
        return (
            <div className="p-2 sm:p-4">
                <div className="max-w-md mx-auto bg-white rounded-xl shadow-lg overflow-hidden">
                    <div className="p-6 text-center">
                        <div className="w-16 h-16 mx-auto mb-4 bg-yellow-100 rounded-full flex items-center justify-center">
                            <RefreshCw className="w-8 h-8 text-yellow-600 animate-spin" />
                        </div>
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">
                            Transferencia en Revisión
                        </h3>
                        <p className="text-gray-600 mb-6">
                            Tu transferencia está siendo revisada por el administrador. Por favor, ten paciencia mientras verificamos tu pago.
                        </p>
                        <button
                            onClick={() => setMostrarMensajeTransferencia(false)}
                            className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            Entendido
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // Mostrar selección de plan al inicio
    if (mostrarSeleccionPlan) {
        return (
            <div className="min-h-screen flex justify-center p-2 sm:p-4">
                <div className="w-full max-w-4xl space-y-6 sm:space-y-8">
                    <div className="text-center space-y-2">
                        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">Seleccione su Plan</h2>
                        <p className="text-sm sm:text-base text-gray-500">Renueve su plan actual o seleccione uno nuevo</p>
                    </div>

                    {loadingPlanes ? (
                        <div className="flex justify-center items-center py-8">
                            <Loader className="w-8 h-8 animate-spin text-blue-600 mr-3" />
                            <span className="text-gray-600">Cargando planes...</span>
                        </div>
                    ) : (
                        <>
                            {planActual && (
                                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                                    <div className="flex items-center gap-3">
                                        <CheckCircle className="w-5 h-5 text-blue-600" />
                                        <div>
                                            <h3 className="font-medium text-blue-900">Plan Actual: {planActual.nombre}</h3>
                                            <p className="text-sm text-blue-700">${planActual.monto} - {planActual.hora_inicio} a {planActual.hora_fin}</p>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                                {planes.map((plan) => (
                                    <div 
                                        key={plan.id_plan} 
                                        className={`border rounded-lg p-4 cursor-pointer transition-all duration-200 ${
                                            planSeleccionado?.id_plan === plan.id_plan 
                                                ? 'border-blue-500 bg-blue-50 shadow-md' 
                                                : 'border-gray-200 hover:border-blue-300 hover:shadow-sm'
                                        }`}
                                        onClick={() => handleSeleccionarPlan(plan)}
                                    >
                                        <div className="text-center">
                                            <div className="flex items-center justify-center gap-2 mb-2">
                                                <h4 className="text-lg font-semibold text-gray-800">
                                                    {plan.nombre}
                                                </h4>
                                                {planActual?.id_plan === plan.id_plan && (
                                                    <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                                                        Actual
                                                    </span>
                                                )}
                                            </div>
                                            <p className="text-2xl font-bold text-blue-600 mb-3">
                                                ${plan.monto}
                                            </p>
                                            {plan.descripcion && renderDescripcion(plan.descripcion)}
                                            <div className="text-sm text-gray-500">
                                                <p><strong>Horario:</strong></p>
                                                <p>{plan.hora_inicio} - {plan.hora_fin}</p>
                                            </div>
                                            {planSeleccionado?.id_plan === plan.id_plan && (
                                                <div className="mt-3">
                                                    <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                                        <CheckCircle className="w-4 h-4 mr-1" />
                                                        Seleccionado
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {planSeleccionado && (
                                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
                                    <button
                                        onClick={procederAlPago}
                                        className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                                        disabled={!planSeleccionado}
                                    >
                                        {planActual?.id_plan === planSeleccionado?.id_plan ? (
                                            <><RefreshCw className="w-4 h-4 inline mr-2" />Renovar Plan</>
                                        ) : (
                                            <>Cambiar a este Plan</>
                                        )}
                                    </button>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        );
    }

    if (!metodoPago) {
        return (
            <div className="min-h-screen flex justify-center p-2 sm:p-4">
                <div className="w-full max-w-md space-y-6 sm:space-y-8">
                    <div className="text-center space-y-2">
                        <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">Seleccione método de pago</h2>
                        <p className="text-sm sm:text-base text-gray-500">Escoja cómo desea realizar su pago</p>
                        {planSeleccionado && (
                            <div className="bg-green-50 border border-green-200 rounded-lg p-3 mt-4">
                                <p className="text-sm text-green-800">
                                    <strong>Plan seleccionado:</strong> {planSeleccionado.nombre} - ${planSeleccionado.monto}
                                </p>
                            </div>
                        )}
                    </div>

                    <div className="space-y-3 sm:space-y-4">
                        <button
                            onClick={() => setMetodoPago('tarjeta')}
                            disabled={transferenciaPendiente}
                            className={`w-full p-3 sm:p-4 border rounded-lg sm:rounded-xl transition-all duration-200 ${
                                transferenciaPendiente 
                                    ? 'bg-gray-100 border-gray-300 cursor-not-allowed opacity-50' 
                                    : 'bg-white/30 border-gray-200 hover:bg-blue-50'
                            }`}
                        >
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2 sm:gap-3">
                                    <CreditCard className={`w-5 h-5 sm:w-6 sm:h-6 ${
                                        transferenciaPendiente ? 'text-gray-400' : 'text-blue-600'
                                    }`} />
                                    <div className="text-left">
                                        <h3 className={`text-sm sm:text-base font-medium ${
                                            transferenciaPendiente ? 'text-gray-500' : 'text-gray-900'
                                        }`}>Tarjeta de Crédito/Débito</h3>
                                        <p className={`text-xs sm:text-sm ${
                                            transferenciaPendiente ? 'text-gray-400' : 'text-gray-500'
                                        }`}>Pago seguro con dLocal Go</p>
                                    </div>
                                </div>
                                {pagoTarjetaPendiente && (
                                    <div className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full text-xs font-medium">
                                        Revisar
                                    </div>
                                )}
                                {transferenciaPendiente && (
                                    <div className="bg-gray-200 text-gray-600 px-2 py-1 rounded-full text-xs font-medium">
                                        Bloqueado
                                    </div>
                                )}
                            </div>
                        </button>

                        <button
                            onClick={() => {
                                if (transferenciaPendiente) {
                                    setMostrarMensajeTransferencia(true);
                                } else {
                                    setMetodoPago('transferencia');
                                }
                            }}
                            disabled={pagoTarjetaPendiente}
                            className={`w-full p-3 sm:p-4 border rounded-lg sm:rounded-xl transition-all duration-200 ${
                                pagoTarjetaPendiente 
                                    ? 'bg-gray-100 border-gray-300 cursor-not-allowed opacity-50' 
                                    : 'bg-white/30 border-gray-200 hover:bg-blue-50'
                            }`}
                        >
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2 sm:gap-3">
                                    <FaExchangeAlt className={`w-5 h-5 sm:w-6 sm:h-6 ${
                                        pagoTarjetaPendiente ? 'text-gray-400' : 'text-blue-600'
                                    }`} />
                                    <div className="text-left">
                                        <h3 className={`text-sm sm:text-base font-medium ${
                                            pagoTarjetaPendiente ? 'text-gray-500' : 'text-gray-900'
                                        }`}>Transferencia Bancaria</h3>
                                        <p className={`text-xs sm:text-sm ${
                                            pagoTarjetaPendiente ? 'text-gray-400' : 'text-gray-500'
                                        }`}>Transferencia directa a nuestra cuenta</p>
                                    </div>
                                </div>
                                {transferenciaPendiente && (
                                    <div className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full text-xs font-medium">
                                        Ver estado
                                    </div>
                                )}
                                {pagoTarjetaPendiente && (
                                    <div className="bg-gray-200 text-gray-600 px-2 py-1 rounded-full text-xs font-medium">
                                        Bloqueado
                                    </div>
                                )}
                            </div>
                        </button>
                    </div>

                    {!pagoTarjetaPendiente && !transferenciaPendiente && tienePagosAnteriores && (
                        <div className="text-center">
                            <button
                                onClick={volverAPlanes}
                                className="text-blue-600 hover:text-blue-800 text-sm underline"
                            >
                                Cambiar plan seleccionado
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="p-2 sm:p-4">
            <div className="flex items-center justify-between mb-4 sm:mb-6">
                <div className="flex items-center gap-2 sm:gap-4">
                    <button
                        onClick={volverASeleccion}
                        className="p-1.5 sm:p-2 flex items-center gap-1 sm:gap-2 text-gray-600 hover:text-blue-600 transition-colors text-sm sm:text-base"
                    >
                        <ArrowLeft className="w-4 h-4 sm:w-5 sm:h-5" />
                        <span>Volver</span>
                    </button>
                    <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
                        {metodoPago === 'tarjeta' && 'Pago con Tarjeta'}
                        {metodoPago === 'transferencia' && 'Transferencia Bancaria'}
                    </h2>
                </div>
            </div>
            
            {planSeleccionado && (
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
                    <p className="text-sm text-blue-800">
                        <strong>Plan:</strong> {planSeleccionado.nombre} - ${planSeleccionado.monto}
                    </p>
                </div>
            )}
            
            {metodoPago === 'tarjeta' && <Pagos planSeleccionado={planSeleccionado} />}
            {metodoPago === 'transferencia' && <Transferencia planSeleccionado={planSeleccionado} />}
        </div>
    );
};

export default ControladorPago;
